export default __webpack_public_path__ + "static/media/banner-bg-dez-anos-25mil-desk.5da48a9b.png";